import Vue from 'vue';
import Vuex from 'vuex';
import logger from './domain/ClientLogger';
import eventBus from './events/eventBus';
import isEqual from 'lodash/isEqual';
import Auth from './domain/Auth';

Vue.use(Vuex);

const state = {
    athlete: null,
    token: null,
    auth: null,
    code: null,
    pagination: {
        descending: true,
        page: 1,
        rowsPerPage: 10,
        sortBy: 'start_date',
        totalItems: 0,
        rowsPerPageItems: [10, 20, 50, 100, 500],
    },
    preferences: {
        distance: 'metres',
        elevation: 'metres',
        speed: 'm/s',
    },
    viewport: {
        bottom: null,
    },
};

const vuexStateName = 'vuex-state';

const localStoragePlugin = (s) => {
    s.subscribe((mutation) => {
        if (mutation.type !== 'initialise') {
            const stateString = JSON.stringify(state);
            logger.log(`saving state for [${mutation.type}]: ${stateString}`);
            localStorage.setItem(vuexStateName, stateString);
        }
    });
};

export default new Vuex.Store({
    state,
    mutations: {
        signedIn(s, payload) {
            s.athlete = payload.athlete;
            s.token = payload.token;
            s.auth = payload.auth;
            s.code = payload.code;
            eventBus.emit('sign-in');
        },
        refreshToken(s, payload: Auth) {
            s.token = payload.accessToken;
            s.auth = payload;
        },
        setPaginationByProps(s, sort) {
            logger.log(`Vuex: setPaginationByProps(${JSON.stringify(sort)})`);
            s.pagination.sortBy = sort.sort;
            s.pagination.descending = sort.direction === 'desc';
            eventBus.emit('pagination-changed', s.pagination);
        },
        setPagination(s, payload) {
            logger.log(`Vuex: setPagination(${JSON.stringify(payload)})`);
            s.pagination = payload;
            eventBus.emit('pagination-changed', payload);
        },
        setPreferences(s, payload) {
            if (!isEqual(s.preferences, payload)) {
                logger.log(`Vuex: setPreferences(${JSON.stringify(payload)})`);
                s.preferences = payload;
                eventBus.emit('preferences-changed', payload);
            }
        },
        signOut(s) {
            s.athlete = null;
            s.auth = null;
            s.token = null;
            eventBus.emit('sign-out');
        },
        setAppViewport(s, payload) {
            s.viewport.bottom = payload.footerTop;
            eventBus.emit('viewport-changed', state.viewport);
        },
        initialise(s) {
            if (localStorage.getItem(vuexStateName)) {
                const stateString = localStorage.getItem(vuexStateName);
                logger.log(`loading state [${stateString}]`);
                this.replaceState(Object.assign(s, JSON.parse(stateString)));
            }
        },
    },
    actions: {
    },
    plugins: [localStoragePlugin],
    getters: {
        pagination(s) {
            return s.pagination;
        },
        preferences(s) {
            return s.preferences;
        },
        viewport(s) {
            return s.viewport;
        },
        currentUser(s) {
            let user = null;
            if (s.athlete) {
                user = {
                    name: `${s.athlete.firstname} ${s.athlete.lastname}`,
                    username: s.athlete.username,
                    city: s.athlete.city,
                    country: s.athlete.country,
                };
            }
            return user;
        },
    },
});
